var React = require( 'react' );
var createReactClass = require('create-react-class');

var TextInput = createReactClass({
  componentDidMount: function(){
    this.handleChange();
  },

  DEFAULT_TEXT: 'no answer',

  handleChange: function(event) {
    const { type } = this.props;
    const value = (event && type === 'number-input') ? parseInt(event.target.value, 10) : null;

    var userResponse = {
        tag: 'text',
        text: (event && event.target.value) || this.DEFAULT_TEXT,
        value: value,
    };
    this.props.response(userResponse);
  },

  handleKeyUp: function(event){
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
  },

  getShowText: function(){
      var showText = '';

      if(this.props.currentResponse[0] && this.props.currentResponse[0].text !== this.DEFAULT_TEXT){
          showText = this.props.currentResponse[0].text || '';
      } else if (this.props.currentResponse[0] && this.props.type === 'number-input') {
          showText = this.props.currentResponse[0].value || '';
      }

      return showText;
  },

  render: function () {
    return (
      <div id="entry" className="row">
      <div className="column small-4 large-2 small-offset-4 large-offset-5 end">
        <input
          type="text"
          placeholder={this.props.helpText}
          onChange={this.handleChange}
          onKeyUp={this.handleKeyUp}
          value={this.getShowText()} />
        </div>
      </div>
    );
  }

});

module.exports = TextInput;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/text/textInput.jsx